"use client"

import { QuarterlyProductMinimumPrice } from "@/components/OrderSummary/_components/QuarterlyProductMinimumPrice/QuarterlyProductMinimumPrice.component"
import { YearlyProductMinimumPrice } from "@/components/OrderSummary/_components/YearlyProductMinimumPrice/YearlyProductMinimumPrice.component"
import { QuarterlyProductTerms } from "@/components/ProductTerms/QuarterlyProductTerms/QuarterlyProductTerms.component"
import { YearlyProductTerms } from "@/components/ProductTerms/YearlyProductTerms/YearlyProductTerms.component"
import { usePaywall } from "@/contexts/paywall/paywall.context"
import { useSiteConfiguration } from "@/contexts/site-configuration/site-configuration.context"

export function FootNotes() {
  const { quarterlyProduct, yearlyProduct } = usePaywall()
  const {
    links: { cancellationGuide },
    productSettings: {
      quarterlyProductTerminationMonths,
      yearlyProductAllowedTerminationMonths,
      yearlyProductTerminationMonths,
    },
  } = useSiteConfiguration()
  return (
    (yearlyProduct || quarterlyProduct) && (
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-0 text-center text-dim text-xs">
        {yearlyProduct !== null ? (
          <div className="mb-2" data-testid="yearly-product-terms">
            <YearlyProductTerms
              footNoteStarCount={1}
              key="product-page-yearly-product-terms"
              minimumPriceComponent={
                <YearlyProductMinimumPrice
                  isVatCalculationEnabled={false}
                  product={yearlyProduct}
                  yearlyProductTerminationMonths={
                    yearlyProductTerminationMonths
                  }
                />
              }
              readmoreUrl={cancellationGuide}
              yearlyProductAllowedTerminationMonths={
                yearlyProductAllowedTerminationMonths
              }
              yearlyProductTerminationMonths={yearlyProductTerminationMonths}
            />
          </div>
        ) : null}

        {quarterlyProduct !== null ? (
          <div data-testid="quarterly-product-terms">
            <QuarterlyProductTerms
              footNoteStarCount={yearlyProduct !== null ? 2 : 1}
              key="product-page-quarterly-product-terms"
              minimumPriceComponent={
                <QuarterlyProductMinimumPrice
                  isVatCalculationEnabled={false}
                  product={quarterlyProduct}
                />
              }
              quarterlyProductTerminationMonths={
                quarterlyProductTerminationMonths
              }
              readmoreUrl={cancellationGuide}
            />
          </div>
        ) : null}
      </div>
    )
  )
}
